jQuery(document).ready(function () {

    // Logo animation on page load
    jQuery('#logo-wrapper').addClass('loaded');

    jQuery('#search-icon').click(function() {
        jQuery(this).toggleClass('is-active');
        jQuery('#sobo-search').toggleClass('is-active');
        if(jQuery(this).hasClass('is-active')) {
            setTimeout(function() {
                jQuery("#ajaxsearchlite1 .prosettings").click();
                jQuery("#ajaxsearchlite1 .prosettings").css('transform', 'rotate(180deg)');
            }, 1000);
        } else {
            jQuery("#ajaxsearchlite1 .prosettings").css('transform', 'rotate(0deg)');
        }
    });

    // Close search when clicking outside
    jQuery(document).click(function(e) {
        if(jQuery('#search-icon').hasClass('is-active')) {
            if(!jQuery(e.target).closest('#sobo-search').length && !jQuery(e.target).is('#search-icon')) {
                jQuery('#search-icon').click();
            }
        }
    });

    jQuery('#mobile-menu .menu-item-has-children > a').click(function(e) {
        if(jQuery(this).siblings('.sub-menu').hasClass('active')) {
            // do nothing
        } else {
            e.preventDefault();
            jQuery(this).siblings('.sub-menu').addClass('active');
            TweenLite.set(jQuery(this).siblings('.sub-menu'), {ease: Power4.easeInOut, height:"auto"});
        }
    })


    // mobile menu toggle
    jQuery("#mobile-toggle").click(function() {

        var $this = jQuery(this),
            $mobilemenu = jQuery("#mobile-navigation"),
            $logo = jQuery("#logo-wrapper");
            

        $this.toggleClass('is-active');
        if(!$this.hasClass("closed")) {

            jQuery(jQuery("#mobile-menu > li").get().reverse()).each(function(i) { 
                TweenLite.to(jQuery(this), 0.2 * i, { ease: Power4.easeInOut, opacity:0});
            });

            TweenLite.to(jQuery('.sobo-meta-wrapper'), 0.1, { ease: Power4.easeInOut, opacity:0});

            TweenLite.to($mobilemenu, 0.5, {ease: Power4.easeInOut, height:0});
            TweenLite.to($logo, 0.5, {ease: Power4.easeInOut, y:0});
            
            $mobilemenu.removeClass("open");
            $this.addClass("closed");
            $logo.addClass('notransition');

        } else {

            jQuery("#mobile-menu > li").each(function(i) {
                TweenLite.to(jQuery(this), 0.2 * i, {ease: Power4.easeInOut, opacity:1});
            });

            TweenLite.to(jQuery('.sobo-meta-wrapper'), 0.2, {delay:0.5, ease: Power4.easeInOut, opacity:1});

            TweenLite.set($mobilemenu, {ease: Power4.easeInOut, height:"auto"});
            jQuery("#mobile-menu").css("maxHeight", jQuery("#mobile-menu").height());
            var menu_height = jQuery('#mobile-navigation').height();
            TweenLite.to($logo, 0.5, {ease: Power4.easeInOut, y:menu_height});
            
            TweenLite.from($mobilemenu, 0.5, {ease: Power4.easeInOut, height:0});
            $this.removeClass("closed");
            $logo.addClass('notransition');
            $mobilemenu.addClass("open");
        }

    });


    // scrollable sections
    jQuery('.scrollable-wrapper').slimScroll({
        height: '100%',
        alwaysVisible: false
    });

    if(Cookies.get("wishList") != undefined) {
        var wishList = jQuery.parseJSON(Cookies.get("wishList"));
        if(wishList != undefined && wishList.length != 0) {
            var wishCount = wishList.length;
            jQuery('#wishlist-icon').addClass('active');
            jQuery('#wishlist-icon .wish-count').text(wishCount);
            jQuery('#view-wishlist').removeClass('hidden');
        }
    } else {
        jQuery('#wishlist-icon').removeClass('active');
        jQuery('#view-wishlist').addClass('hidden');
    }

    if(jQuery('#gform_1').length) {
        jQuery('#gform_1 .gfield_label .gfield_required').text('(required)');
    }


    var colors = ['#ffc627', '#148ca8', '#e32c87'];
    var items = document.querySelectorAll('.menu__item');
    var lastColor = null;
    var colorPool = colors.slice();

    function shuffleArray(array) {
        for (var i = array.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }
        return array;
    }

    for (var idx = 0; idx < items.length; idx++) {
        var item = items[idx];
        // After every 3 items, shuffle the color pool
        if (idx > 0 && idx % 3 === 0) {
            colorPool = shuffleArray(colorPool.slice());
        }
        // Filter out the last used color
        var available = [];
        for (var c = 0; c < colorPool.length; c++) {
            if (colorPool[c] !== lastColor) {
                available.push(colorPool[c]);
            }
        }
        var color = available[Math.floor(Math.random() * available.length)];
        item.style.setProperty('--menu-item-color', color);
        lastColor = color;
    }


    document.addEventListener('DOMContentLoaded', function() {

        var header = document.getElementById('site-header');
        var lastScrollTop = 0;
        var delta = 10; // minimum scroll to trigger
        var headerHeight = header.offsetHeight;

        // Reserve space so content doesn't jump
        document.body.style.paddingTop = headerHeight + "px";

        window.addEventListener('scroll', function() {
            var st = window.pageYOffset || document.documentElement.scrollTop;

            // Ignore tiny scrolls
            if(Math.abs(st - lastScrollTop) <= delta) return;

            if (st > lastScrollTop && st > headerHeight) {
            // Scroll down → slide up
            TweenMax.to(header, 0.4, {y: -headerHeight, ease: Power2.easeOut});
            } else if (st + window.innerHeight < document.body.scrollHeight) {
            // Scroll up → slide down
            TweenMax.to(header, 0.4, {y: 0, ease: Power2.easeOut});
            }

            lastScrollTop = st;
        });
    });
});